/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_PickupInputs */

const vi_order_action_pickup = /** @type {(inputs: Order_Action_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận đơn`)
};

/**

* @param {Order_Action_PickupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_pickup = /** @type {((inputs?: Order_Action_PickupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_PickupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_pickup(inputs)
});